export default "__VITE_ASSET__CFz_TQtu__"